import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';


const _directiveDependencies = [];
const _controllerDependencies = ['$scope', 'UserRestService', 'Util',
    'Auth', '$rootScope'];

/**
 * @ngdoc directive
 * @name directives.controller.securityPasswordController
 *
 * @description
 * change password controller
 */
class SecurityPasswordController {

    /**
     * @param  {any} $scope
     * @param  {any} UserRestService
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} $rootScope
     */
    constructor($scope, UserRestService, Util, Auth, $rootScope) {

        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$scope.resetPasswordFailedAttempts = 0;
        this.Auth = Auth;
        this.MeRepository = MeRepository;
        this.UserRestService = UserRestService;
        this.Util = Util;
        this.user = MeRepository.getMyUser();
        this.$scope.passwordRegExp = this.Util.getPasswordValidationRegExp();
        this.$scope.submitted = false;
        this.$scope.loading = false;
        this.passwordScore = {};
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

    }

    /**
     * @ngdoc directive
     * @name directives.controller.securityPasswordController#changePassword
     * @methodOf directives.controller.securityPasswordController
     *
     * @description
     * changes the user password
     */
    changePassword() {

        const payload = {
            data: {
                id: this.user.id,
                type: this.user.type,
                attributes: {
                    password: this.$scope.newPassword,
                },
            },
            meta: {
                logout: this.$scope.logoutFromAllDevices,
                old_password: this.$scope.oldPassword,
            },
        };

        this.getPasswordScore(this.$scope.newPassword);

        const passwordsAreDifferent = this.$scope.resetPasswordForm.oldPassword.$viewValue !==
                                    this.$scope.resetPasswordForm.newPassword.$viewValue;


        this.$scope.resetPasswordForm.oldPassword.$setValidity('serverValidation', true);

        const formIsValid =
            this.$scope.resetPasswordForm.$valid &&
            passwordsAreDifferent &&
            this.passwordScore.valid;

        this.$scope.submitted = true;

        if (formIsValid) {

            this.$scope.loading = true;

            this.UserRestService.update(this.user.id, payload).then(() => {

                this.$scope.oldPassword = null;
                this.$scope.newPassword = null;
                this.$scope.submitted = false;
                this.$scope.loading = false;

                Mixpanel.send('ConnectWeb Change Password Click', {
                    Logout: this.$scope.logoutFromAllDevices ? 'true' : 'false',
                });

                this.Auth.logOut();

            }).catch((error) => {

                const errorCode =
                    (error.data.errors && error.data.errors[0]) ? error.data.errors[0].code : false;

                this.$scope.loading = false;
                switch (errorCode) {

                // if the current password is not valid
                case '21114':
                    this.$scope.resetPasswordFailedAttempts += 1;
                    this.$scope.resetPasswordForm.oldPassword.$setPristine();
                    this.$scope.resetPasswordForm.oldPassword.$setValidity('serverValidation', false);
                    break;

                default:
                    Alert.error('cw.notification.security.change_password.error');
                    break;

                }

            });

        }

    }

    /**
     * @ngdoc directive
     * @name directives.controller.securityPasswordController#setEmail
     * @methodOf directives.controller.securityPasswordController
     *
     * @description
     * set the email for the forgot page on the rootScope
     */
    setEmail() {

        this.$rootScope.forgotEmail = this.user.attributes.email;

    }

    /**
     * @ngdoc directive
     * @name directives.controller.securityPasswordController#showPassword
     * @methodOf directives.controller.securityPasswordController
     *
     * @description
     * makes the input fields type - text or password
     */
    showPassword(inputId) {

        const input = angular.element(`#${inputId}`)[0];

        input.type = input.type === 'text' ? 'password' : 'text';

        if (inputId === 'oldPassword') {

            this.$scope.oldInputType = input.type;

        } else if (inputId === 'newPassword') {

            this.$scope.newInputType = input.type;

        }

    }

    getPasswordScore(password) {

        this.passwordScore = this.Util.getPasswordScore(password);

    }

}

/**
 * @ngdoc directive
 * @name directives.securityPasswordDirective
 *
 * @description
 * change password directive
 */
class SecurityPasswordDirective {

    constructor() {

        this.template = require('./security-password.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push((
            $scope, UserRestService,
            Util, Auth, $rootScope,
        ) =>
            new SecurityPasswordController(
                $scope, UserRestService,
                Util, Auth, $rootScope,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'securityPasswordCtrl';

    }

}

_directiveDependencies.push(() => new SecurityPasswordDirective());


angular.module('directives')
    .directive('securityPassword', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/security/security-password/security-password.js